import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SWMSUnitGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const roleId = Number(localStorage.getItem('globalStoreRoleId'));
    const blockedRoles = [1, 2, 3, 4];   // ❌ No subscription access

    if (blockedRoles.includes(roleId)) {
      this.router.navigate(['/dashboard']);   // or any safe page
      return false;
    }

    return true;
  }
}
